import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const allDisciplines = [
  { key: 'kite', text: 'Kitefoil' },
  { key: 'wing', text: 'Wingfoil' },
  { key: 'wind', text: 'Windfoil' },
  { key: 'surf', text: 'Surf foil' },
  { key: 'pump', text: 'Pumping' },
  { key: 'dw', text: 'Downwind' },
  { key: 'sup', text: 'SUP foil' },
];

const allProducts = {
  foil_kits: [
    {
      name: 'SABFOIL Kit M101-W671-S399-FK647',
      price: 2049,
      deal_price: 1229,
      in_stock: true,
      image: require('@/assets/images/products/kit_101-671-399-647.jpg'),
      description: 'Un foil de freerace accessible qui permet d’aller vraiment vite.',
      disciplines: ['kite'],
      details: [
        { txt: 'M101' },
        { txt: 'W671 (570cm2)' },
        { txt: 'S399 (207cm2)' },
        { txt: 'FK647' },
      ],
    },
    {
      name: 'SABFOIL Kit M93K-W695-S399-F653K',
      price: 1849,
      deal_price: 1294,
      in_stock: true,
      image: require('@/assets/images/products/kit_93-695-399-653.jpg'),
      description: 'Un foil extrêmement polyvalent pour les riders de tous niveaux. \n ' +
      'Vitesse, maniabilité, capacité à sauter haut. Ce foil excelle en freeride et freestyle. \n ' +
      'Le système modulable Kraken garantit un maximum de compatibilité dans la gamme. \n ' +
      'Possibilité d’upgrade avec le Quick Release System.',
      disciplines: ['kite'],
      details: [
        { txt: 'Mast M93K - 930mm' },
        { txt: 'Wing W695 - 770cm2' },
        { txt: 'Stab S399 - 207cm2' },
        { txt: 'Fuselage F653K - 653mm' },
        { txt: 'Mast plate P02K' },
      ],
    },
    {
      name: 'SABFOIL Kit MEDUSA PRO 869-395-93',
      price: 2209,
      in_stock: false,
      image: require('@/assets/images/products/KMP869-395-93_A.jpg'),
      description: 'La ligne Medusa PRO est un concentré de vitesse et de puissance. \n ' +
      'Conçu spécifiquement pour une accélération supérieure et des vitesses de pointe élevées, ce foil offre un pop incroyable et, grâce à la connexion T8 super solide, il est le choix idéal pour les sessions de power freestyle et pour l’exécution de manœuvres engagées. \n ' +
      'La Medusa PRO 869 est meilleure en wing et wind dans des conditions de vent faible à moyen, mais  également en kite par vent léger. \n ' +
      'Livré avec bag et Quick Release System Titanium.',
      disciplines: ['wing', 'kite'],
      details: [
        { txt: 'Mast M93K/PF - 930mm' },
        { txt: 'Wing WMP869 - 854cm2' },
        { txt: 'Stab S395/PF - 198cm2' },
        { txt: 'Fuselage F663K - 663mm' },
        { txt: 'Mast plate CP02K/Ti' },
      ],
    },
    {
      name: 'SABFOIL Kit Leviathan 731150',
      price: 2029,
      deal_price: 1599,
      in_stock: true,
      image: require('@/assets/images/products/kit_73-1150-380-703.jpg'),
      description: 'Une glisse exceptionnelle, un décollage rapide et une belle vitesse de pointe caractérisent ce foil qui conviendra autant à une session de pumping qu’à du freeride en wing. \n ' +
      'Livré avec bag et Quick Release System.',
      disciplines: ['wing', 'pump', 'sup', 'dw'],
      details: [
        { txt: 'Mast M73PLK - 730mm' },
        { txt: 'Wing WL1150 - 1580cm2' },
        { txt: 'Stab S380 - 180cm2' },
        { txt: 'Fuselage F703K - 703mm' },
        { txt: 'Mast plate CP02K' },
      ],
    },
    {
      name: 'SABFOIL Kit Leviathan 1350-370-73PL',
      price: 2339,
      in_stock: true,
      image: require('@/assets/images/products/KL1350-370-73PL_A.jpg'),
      description: 'Une glisse exceptionnelle, un décollage rapide et une vitesse de pointe intéressante caractérisent ce foil qui conviendra autant à une session de pumping pour débutant ou expert qu’à du downwind en conditions légères ou du freeride light wind en wing. \n ' +
      'Livré avec bag et Quick Release System Titanium.',
      disciplines: ['wing', 'pump', 'sup', 'dw'],
      details: [
        { txt: 'Mast M73PLK/PF - 730mm' },
        { txt: 'Wing WL1350/PF - 1870cm2' },
        { txt: 'Stab S370/PF - 195cm2' },
        { txt: 'Fuselage F663K - 663mm' },
        { txt: 'Mast plate CP02K/Ti' },
      ],
    },
  ],

  boards: [
    {
      name: 'SABFOIL Board B08 Carbon - 8L',
      price: 819,
      deal_price: 573,
      in_stock: true,
      image: require('@/assets/images/products/board_b08.jpg'),
      description: 'Super compacte pour le pumping et le kite strapless. \n Avec sa petite taille elle est faite pour voyager. ',
      disciplines: ['kite', 'pump'],
      details: [
        { txt: 'B08' },
        { txt: '90cm x 38,9cm x 3cm' },
        { txt: '8 L' },
      ],
    },
    {
      name: 'SABFOIL Board B14 Carbon - 14 L',
      price: 999,
      deal_price: 599,
      in_stock: true,
      image: require('@/assets/images/products/board_b14.jpg'),
      description: 'La planche parfaite, une polyvalence extrême, elle conviendra autant au débutant motivé qu’à l’expert. \n Avec sa petite taille elle est faite pour voyager. ',
      disciplines: ['kite', 'pump'],
      details: [
        { txt: 'B14' },
        { txt: '108cm x 46,5cm x 5cm' },
        { txt: '14 L' },
      ],
    },
    {
      name: 'SABFOIL Board B21 Carbon - 21 L',
      price: 1019,
      deal_price: 611,
      in_stock: true,
      image: require('@/assets/images/products/board_b21.jpg'),
      description: 'Planche très polyvalente et compacte, pour les riders qui recherchent un peu plus de volume que celui offert par la B14.',
      disciplines: ['kite'],
      details: [
        { txt: 'B21' },
        { txt: '128cm x 45,5cm x 5cm' },
        { txt: '21 L' },
      ],
    },
    {
      name: 'SABFOIL 8L Pump Foilboard',
      price: 749,
      in_stock: false,
      image: require('@/assets/images/products/B08-PUMP_A.jpg'),
      description: 'Super compacte pour le pumping et le kite strapless. \n Avec sa petite taille elle est faite pour voyager. ',
      disciplines: ['kite', 'pump'],
      details: [
        { txt: 'B08/PUMP' },
        { txt: '8 L' },
        { txt: 'Length: 2’9’’' },
        { txt: 'Width: 15,28’’' },
        { txt: 'thickness: 1,18’’' },
      ],
    },
    {
      name: 'SABFOIL 12L Pump Foilboard',
      price: 979,
      in_stock: false,
      image: require('@/assets/images/products/B12-PUMP_A.jpg'),
      description: 'Compacte, pour le pumping et le kite strapless. \n Avec sa petite taille elle est faite pour voyager. ',
      disciplines: ['kite', 'pump'],
      details: [
        { txt: 'B12/PUMP' },
        { txt: 'Volume: 12 L' },
        { txt: 'Length: 2’9’’' },
        { txt: 'Width: 15,28’’' },
        { txt: 'thickness: 1,18’’' },
      ],
    },
    {
      name: 'SABFOIL 14L Kite Foilboard',
      price: 999,
      in_stock: false,
      image: require('@/assets/images/products/B14-KITE_A.jpg'),
      description: 'La planche parfaite, une polyvalence extrême, elle conviendra autant au débutant motivé qu’à l’expert, en freeride ou en freestyle. \n Avec sa petite taille elle est faite pour voyager. ',
      disciplines: ['kite', 'pump'],
      details: [
        { txt: 'B14/KITE' },
        { txt: '14 L' },
        { txt: 'Length: 3’5’’' },
        { txt: 'Width: 17,71’’' },
        { txt: 'thickness: 1,57’’' },
      ],
    },
    {
      name: 'SABFOIL 21L Kite Foilboard',
      price: 1049,
      in_stock: false,
      image: require('@/assets/images/products/B21-KITE_A.jpg'),
      description: 'Planche très polyvalente et compacte, pour les riders qui recherchent un peu plus de volume que celui offert par la B14/KITE.',
      disciplines: ['kite'],
      details: [
        { txt: 'B21/KITE' },
        { txt: '21 L' },
        { txt: 'Length: 4’2’’' },
        { txt: 'Width: 17,71’’' },
        { txt: 'thickness: 1,96’’' },
      ],
    },
    {
      name: 'SABFOIL DINAMO 55L Freestyle Foilboard',
      price: 1349,
      in_stock: false,
      image: require('@/assets/images/products/B55-DIN_A.jpg'),
      description: 'Une board sans compromis pour les riders expérimentés adeptes de freestyle engagé. \n Avec sa petite taille elle est faite pour voyager. \n Toutes les tailles sont disponibles sur demande.',
      disciplines: ['wing'],
      details: [
        { txt: 'B55/DIN' },
        { txt: '55 L' },
        { txt: 'Length: 4’6’’' },
        { txt: 'Width: 20,86’’' },
        { txt: 'thickness: 3,27’’' },
      ],
    },
    {
      name: 'SABFOIL VELOCE 80L Freeride Pro Foilboard',
      price: 1449,
      in_stock: false,
      image: require('@/assets/images/products/B80-VEL-A.jpg'),
      description: 'Une board très polyvalente pour le freeride et le freestyle. \n Toutes les tailles sont disponibles sur demande.',
      disciplines: ['wing'],
      details: [
        { txt: 'B80/VEL' },
        { txt: '80 L' },
        { txt: 'Length: 5’5’’' },
        { txt: 'Width: 24,50’’' },
        { txt: 'thickness: 3,76’’' },
      ],
    },
    {
      name: 'SABFOIL TORPEDO 100L Downwind Free Foilboard',
      price: 1649,
      in_stock: false,
      image: require('@/assets/images/products/B100-TOR_A.jpg'),
      description: 'Une board très polyvalente pour le wing light wind et le downwind. \n Toutes les tailles sont disponibles sur demande.',
      disciplines: ['wing', 'dw'],
      details: [
        { txt: 'B100/TOR' },
        { txt: '100 L' },
        { txt: 'Length: 6’3’’' },
        { txt: 'Width: 19,90’’' },
        { txt: 'thickness: 6,06’’' },
      ],
    },
    {
      name: 'SABFOIL GENESI 110L Freeride Foilboard',
      price: 1599,
      in_stock: false,
      image: require('@/assets/images/products/B110-GEN_A.jpg'),
      description: 'Une board très stable et facile d’accès pour les riders qui débutent en wingfoil. \n Toutes les tailles sont disponibles sur demande.',
      disciplines: ['wing'],
      details: [
        { txt: 'B110/GEN' },
        { txt: '110 L' },
        { txt: 'Length: 5’4’’' },
        { txt: 'Width: 28,00’’' },
        { txt: 'thickness: 4,55’’' },
      ],
    },
    {
      name: 'SABFOIL SILURO 115L Downwind Pure Foilboard',
      price: 1899,
      in_stock: false,
      image: require('@/assets/images/products/B115-SIL_A.jpg'),
      description: 'Une board très accessible et facile à faire voler en downwind ou sur eau plate, avec une paddle ou en wing. \n Toutes les tailles sont disponibles sur demande.',
      disciplines: ['wing', 'sup', 'dw'],
      details: [
        { txt: 'B115/SIL' },
        { txt: '115 L' },
        { txt: 'Length: 7’5’’' },
        { txt: 'Width: 20,47’’' },
        { txt: 'thickness: 6,06’’' },
      ],
    },

  ],
  wings: [
    {
      name: 'MOSES Wing 558 - 550cm2',
      price: 342,
      deal_price: 189,
      deals_only: true,
      in_stock: true,
      image: require('@/assets/images/products/wing_558n.jpg'),
      description: 'Une aile all round très performante, rapide, et pour sauter haut!',
      disciplines: ['kite'],
      details: [
        { txt: 'W558' },
        { txt: 'Surface 550cm2' },
        { txt: 'Span 558mm' },
        { txt: 'Chord 120mm' },
        { txt: 'Aspect ratio 6,3' },
        { txt: 'Connection type T6 (small chord, M6 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing 590Y - 650cm2',
      price: 459,
      deal_price: 321,
      in_stock: true,
      image: require('@/assets/images/products/wing_590.jpg'),
      description: 'L’aile à tout faire qui conviendra aussi bien au débutant qu’à l’expert. \n Stable et rapide, elle offre un bon lift et des belles performances. Certifiée IKA Youth Foil Class.',
      disciplines: ['kite'],
      details: [
        { txt: 'W590Y' },
        { txt: 'Surface 650cm2' },
        { txt: 'Span 590mm' },
        { txt: 'Chord 132mm' },
        { txt: 'Aspect ratio 5,2' },
        { txt: 'Connection type T6 (small chord, M6 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing 633 M6 - 1250cm2',
      price: 449,
      deal_price: 269,
      in_stock: true,
      image: require('@/assets/images/products/wing_633.jpg'),
      description: 'Très fun, la W633 permet aussi bien de tourner sur place à très basse vitesse que de s’offrir une session de carving radical dans un vent soutenu! \n \n ' +
      'Compatible uniquement avec les fuselages FS710 et FW900',
      disciplines: ['kite'],
      details: [
        { txt: 'W633' },
        { txt: 'Surface 1250cm2' },
        { txt: 'Span 633mm' },
        { txt: 'Chord 256mm' },
        { txt: 'Aspect ratio 3,3' },
        { txt: 'Connection type: big chord, M6 screws' },
      ],
    },
    {
      name: 'SABFOIL Wing Tortuga 633 PF - 1250cm2',
      price: 499,
      in_stock: false,
      image: require('@/assets/images/products/WT633-PF_A.jpg'),
      description: 'Très fun, la W633 permet aussi bien de tourner sur place à très basse vitesse que de s’offrir une session de carving radical dans un vent soutenu! \n \n ',
      disciplines: ['kite'],
      details: [
        { txt: 'WT633/PF' },
        { txt: 'Surface 1250cm2' },
        { txt: 'Volume 1681cm3' },
        { txt: 'Span 633mm' },
        { txt: 'Chord 256mm' },
        { txt: 'Aspect ratio 3,3' },
        { txt: 'Connection type: big chord, M8 screws' },
      ],
    },
    {
      name: 'SABFOIL Wing Medusa PRO 669 - 548cm2',
      price: 499,
      in_stock: true,
      image: require('@/assets/images/products/WMP669_A.jpg'),
      description: 'La ligne Medusa PRO est un concentré de vitesse et de puissance. \n ' +
      'Conçue spécifiquement pour une accélération supérieure et des vitesses de pointe élevées, cette aile offre un pop incroyable et, grâce à la connexion T8 super solide, elle est le choix idéal pour les sessions de power freestyle et pour l’exécution de manœuvres engagées. \n ' +
      'La Medusa PRO 669 est meilleure en wing et kite dans des conditions de vent fort. Très gros lift pour sa surface.',
      disciplines: ['kite', 'wing'],
      details: [
        { txt: 'WMP669' },
        { txt: 'Surface 548cm2' },
        { txt: 'Span 669mm' },
        { txt: 'Chord 120mm' },
        { txt: 'Aspect ratio 8,14' },
        { txt: 'Connection type: big chord, M8 screws' },
      ],
    },
    {
      name: 'SABFOIL Wing Blade 671 PF - 570cm2',
      price: 479,
      in_stock: true,
      image: require('@/assets/images/products/WB671-PF_A.jpg'),
      description: 'Une aile très performante. Son profil fin permet une vitesse élevée et un carving agressif. \n Une pure aile de race, mais très accessible et polyvalente.',
      disciplines: ['kite', 'wing', 'wind', 'surf'],
      details: [
        { txt: 'W671/PF' },
        { txt: 'Surface 570cm2' },
        { txt: 'Volume 373cm3' },
        { txt: 'Span 670mm' },
        { txt: 'Chord 115mm' },
        { txt: 'Aspect ratio 7,8' },
        { txt: 'Connection type T6 (small chord, M6 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Razor PRO 675 - 550cm2',
      price: 489,
      in_stock: false,
      image: require('@/assets/images/products/WRP675_A.jpg'),
      description: 'Surf et downwind sont les domaines de prédilection de la gamme Razor PRO. Glisse et portance exceptionnelles pour sa petite taille.',
      disciplines: ['kite', 'wing', 'surf', 'dw'],
      details: [
        { txt: 'WRP675' },
        { txt: 'Surface 550cm2' },
        { txt: 'Volume cm3' },
        { txt: 'Span 680mm' },
        { txt: 'Chord mm' },
        { txt: 'Aspect ratio ' },
        { txt: 'Connection type T6 (small chord, M6 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing 679 - 990cm2',
      price: 449,
      deal_price: 291,
      in_stock: true,
      image: require('@/assets/images/products/wing_679.jpg'),
      description: 'Plus rapide et offrant un meilleur contrôle à haute vitesse que la W633, c’est l’aile parfaite pour tracer des longues courbes rapides dans les vagues en gardant la possibilité d’être sur le foil aussi à basse vitesse. \n \n ' +
      'Compatible uniquement avec les fuselages FS710 et FW900',
      disciplines: ['kite', 'wing'],
      details: [
        { txt: 'W679' },
        { txt: 'Surface 990cm2' },
        { txt: 'Span 679mm' },
        { txt: 'Chord 198mm' },
        { txt: 'Aspect ratio 4,6' },
        { txt: 'Connection type: big chord, M6 screws' },
      ],
    },
    {
      name: 'MOSES Wing 695 - 770cm2',
      price: 469,
      deal_price: 258,
      deals_only: true,
      used: true,
      in_stock: true,
      image: require('@/assets/images/products/wing_695-old.jpg'),
      description: 'Vitesse, maniabilité, capacité à sauter haut, polyvalence: une aile très aboutie. Occasion en bon état à part quelques griffures.',
      disciplines: ['kite'],
      details: [
        { txt: 'W695' },
        { txt: 'Surface 770cm2' },
        { txt: 'Span 695mm' },
        { txt: 'Chord 131mm' },
        { txt: 'Aspect ratio 6,3' },
        { txt: 'Connection type T6 (small chord, M6 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing 695 - 770cm2',
      price: 469,
      deal_price: 304,
      in_stock: true,
      image: require('@/assets/images/products/wing_695.jpg'),
      description: 'Vitesse, maniabilité, capacité à sauter haut, polyvalence: une aile très aboutie.',
      disciplines: ['kite'],
      details: [
        { txt: 'W695' },
        { txt: 'Surface 770cm2' },
        { txt: 'Span 695mm' },
        { txt: 'Chord 131mm' },
        { txt: 'Aspect ratio 6,3' },
        { txt: 'Connection type T6 (small chord, M6 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing 699 - 880cm2',
      price: 499,
      deal_price: 349,
      in_stock: true,
      image: require('@/assets/images/products/wing_699.jpg'),
      description: 'Aile polyvalente et bien fun. \n ' +
      'Manoeuvrante, facile, elle offre un lift énorme pour sa surface.',
      disciplines: ['kite', 'wing'],
      details: [
        { txt: 'W699' },
        { txt: 'Surface 880cm2' },
        { txt: 'Volume 1052cm3' },
        { txt: 'Span 699mm' },
        { txt: 'Chord 170mm' },
        { txt: 'Aspect ratio 5,75' },
        { txt: 'Connection type T8 (big chord, M8 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Medusa 699 PF - 880cm2',
      price: 499,
      in_stock: false,
      image: require('@/assets/images/products/WM699-PF_A.jpg'),
      description: 'Aile polyvalente et bien fun. \n ' +
      'Manoeuvrante, facile, elle offre un lift énorme pour sa surface.',
      disciplines: ['kite', 'wing'],
      details: [
        { txt: 'WM699/PF' },
        { txt: 'Surface 880cm2' },
        { txt: 'Volume 1052cm3' },
        { txt: 'Span 699mm' },
        { txt: 'Chord 170mm' },
        { txt: 'Aspect ratio 5,75' },
        { txt: 'Connection type T8 (big chord, M8 screws)' },
      ],
    },
    {
      name: 'MOSES Wing 718 - 740cm2',
      price: 468,
      deal_price: 280,
      in_stock: true,
      image: require('@/assets/images/products/wing_718.jpg'),
      description: 'Une aile de free race, super stable à haute vitesse et permettant de rester sur le foil à vitesse réduite.',
      disciplines: ['kite'],
      details: [
        { txt: 'W718' },
        { txt: 'Surface 740cm2' },
        { txt: 'Span 718mm' },
        { txt: 'Chord 134mm' },
        { txt: 'Aspect ratio 6,95' },
        { txt: 'Connection type T6 (small chord, M6 screws)' },

      ],
    },
    {
      name: 'SABFOIL Wing 730 - 1050cm2',
      price: 479,
      deal_price: 335,
      in_stock: true,
      image: require('@/assets/images/products/wing_730.jpg'),
      description: 'Une aile pour surfer les vagues.',
      disciplines: ['wing', 'surf'],
      details: [
        { txt: 'W730' },
        { txt: 'Surface 1050cm2' },
        { txt: 'Volume 1295cm3' },
        { txt: 'Span 730mm' },
        { txt: 'Chord 170mm' },
        { txt: 'Aspect ratio 5,0' },
        { txt: 'Connection type T8 (big chord, M8 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Onda 730 PF - 1050cm2',
      price: 479,
      in_stock: false,
      image: require('@/assets/images/products/WO730-PF_A.jpg'),
      description: 'Une aile pour surfer les vagues.',
      disciplines: ['wing', 'surf'],
      details: [
        { txt: 'WO730/PF' },
        { txt: 'Surface 1050cm2' },
        { txt: 'Volume 1295cm3' },
        { txt: 'Span 730mm' },
        { txt: 'Chord 170mm' },
        { txt: 'Aspect ratio 5,0' },
        { txt: 'Connection type T8 (big chord, M8 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing 740 - 702cm2',
      price: 499,
      deal_price: 374,
      in_stock: true,
      image: require('@/assets/images/products/wing_740.jpg'),
      description: 'Une aile pour aller très vite dans toutes les disciplines. Un beau lift et de la maniabilité à basse vitesse.',
      disciplines: ['kite', 'wing', 'wind'],
      details: [
        { txt: 'W740' },
        { txt: 'Surface 702cm2' },
        { txt: 'Volume 447cm3' },
        { txt: 'Span 740mm' },
        { txt: 'Chord 130mm' },
        { txt: 'Aspect ratio 8,34' },
        { txt: 'Connection type T6 (small chord, M6 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Blade 740 - 702cm2',
      price: 499,
      deal_price: 399,
      in_stock: true,
      image: require('@/assets/images/products/wing_B740.jpg'),
      description: 'Une aile pour aller très vite dans toutes les disciplines. Un beau lift et de la maniabilité à basse vitesse.',
      disciplines: ['kite', 'wing', 'wind'],
      details: [
        { txt: 'WB740' },
        { txt: 'Surface 702cm2' },
        { txt: 'Volume 447cm3' },
        { txt: 'Span 740mm' },
        { txt: 'Chord 130mm' },
        { txt: 'Aspect ratio 8,34' },
        { txt: 'Connection type T6 (small chord, M6 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Blade 740 PF - 702cm2',
      price: 499,
      in_stock: true,
      image: require('@/assets/images/products/WB740-PF_A.jpg'),
      description: 'Une aile pour aller très vite dans toutes les disciplines. Un beau lift et de la maniabilité à basse vitesse.',
      disciplines: ['kite', 'wing', 'wind'],
      details: [
        { txt: 'WB740/PF' },
        { txt: 'Surface 702cm2' },
        { txt: 'Volume 447cm3' },
        { txt: 'Span 740mm' },
        { txt: 'Chord 130mm' },
        { txt: 'Aspect ratio 8,34' },
        { txt: 'Connection type T6 (small chord, M6 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Medusa PRO 769 - 700cm2',
      price: 529,
      in_stock: true,
      image: require('@/assets/images/products/WMP769_A.jpg'),
      description: 'La ligne Medusa PRO est un concentré de vitesse et de puissance. \n ' +
      'Conçue spécifiquement pour une accélération supérieure et des vitesses de pointe élevées, cette aile offre un pop incroyable et, grâce à la connexion T8 super solide, elle est le choix idéal pour les sessions de power freestyle et pour l’exécution de manœuvres engagées. \n ' +
      'La Medusa PRO 769 est meilleure en wing, wind et kite dans des conditions de vent moyen à fort.',
      disciplines: ['kite', 'wing', 'wind'],
      details: [
        { txt: 'WMP769' },
        { txt: 'Surface 700cm2' },
        { txt: 'Span 769mm' },
        { txt: 'Chord 133,2mm' },
        { txt: 'Aspect ratio 8,44' },
        { txt: 'Connection type: big chord, M8 screws' },
      ],
    },
    {
      name: 'SABFOIL Wing Razor PRO 775 - 631cm2',
      price: 499,
      in_stock: false,
      image: require('@/assets/images/products/wing_RP775.jpg'),
      description: 'Surf et downwind sont les domaines de prédilection de la gamme Razor PRO. Glisse et portance exceptionnelles pour sa petite taille.',
      disciplines: ['wing', 'wind', 'surf', 'dw'],
      details: [
        { txt: 'WRP775' },
        { txt: 'Surface 631cm2' },
        { txt: 'Volume 543cm3' },
        { txt: 'Span 780mm' },
        { txt: 'Chord 100mm' },
        { txt: 'Aspect ratio 9,64' },
        { txt: 'Connection type T6 (small chord, M6 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Razor 780 used - 631cm2',
      price: 489,
      deal_price: 289,
      used: true,
      in_stock: true,
      image: require('@/assets/images/products/wing_R780.jpg'),
      description: 'Une aile qui décolle rapidement et permet d’aller relativement vite. Sa maniabilité à basse vitesse et sa stabilité à haute vitesse la rendent très polyvalente. Glisse et portance exceptionnelles pour sa petite surface. Aile d’occasion en bon état.',
      disciplines: ['wing', 'surf', 'dw'],
      details: [
        { txt: 'WR780' },
        { txt: 'Surface 631cm2' },
        { txt: 'Volume 546cm3' },
        { txt: 'Span 780mm' },
        { txt: 'Chord 100mm' },
        { txt: 'Aspect ratio 9,64' },
        { txt: 'Connection type T6 (small chord, M6 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Razor 780 - 631cm2',
      price: 489,
      deal_price: 342,
      in_stock: true,
      image: require('@/assets/images/products/wing_R780.jpg'),
      description: 'Une aile qui décolle rapidement et permet d’aller relativement vite. Sa maniabilité à basse vitesse et sa stabilité à haute vitesse la rendent très polyvalente. Glisse et portance exceptionnelles pour sa petite surface.',
      disciplines: ['wing', 'surf', 'dw'],
      details: [
        { txt: 'WR780' },
        { txt: 'Surface 631cm2' },
        { txt: 'Volume 546cm3' },
        { txt: 'Span 780mm' },
        { txt: 'Chord 100mm' },
        { txt: 'Aspect ratio 9,64' },
        { txt: 'Connection type T6 (small chord, M6 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Medusa 799 - 1100cm2',
      price: 509,
      deal_price: 407,
      in_stock: true,
      image: require('@/assets/images/products/wing_M799.jpg'),
      description: 'Une aile dessinée en collaboration avec le rider pro Balz Müller. \n Manoeuvrante et agile, parfaite pour le freestyle en wing.',
      disciplines: ['wing', 'wind'],
      details: [
        { txt: 'WM799' },
        { txt: 'Surface 1100cm2' },
        { txt: 'Volume 1174cm3' },
        { txt: 'Span 800mm' },
        { txt: 'Chord 170mm' },
        { txt: 'Aspect ratio 5,8' },
        { txt: 'Connection type T8 (big chord, M8 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Medusa 799 PF - 1100cm2',
      price: 509,
      in_stock: true,
      image: require('@/assets/images/products/WM799-PF_A.jpg'),
      description: 'Une aile dessinée en collaboration avec le rider pro Balz Müller. \n Manoeuvrante et agile, parfaite pour le freestyle en wing.',
      disciplines: ['wing', 'wind'],
      details: [
        { txt: 'WM799/PF' },
        { txt: 'Surface 1100cm2' },
        { txt: 'Volume 1174cm3' },
        { txt: 'Span 800mm' },
        { txt: 'Chord 170mm' },
        { txt: 'Aspect ratio 5,8' },
        { txt: 'Connection type T8 (big chord, M8 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing 800 - 840cm2',
      price: 509,
      deal_price: 330,
      in_stock: true,
      image: require('@/assets/images/products/wing_800.jpg'),
      description: 'Un design pour aller vite en wing, wind ou surf.',
      disciplines: ['wing', 'wind'],
      details: [
        { txt: 'W800' },
        { txt: 'Surface 840cm2' },
        { txt: 'Volume 565cm3' },
        { txt: 'Span 800mm' },
        { txt: 'Chord 129,5mm' },
        { txt: 'Aspect ratio 7,6' },
        { txt: 'Connection type T6 (small chord, M6 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Blade 800 PF - 840cm2',
      price: 509,
      in_stock: false,
      image: require('@/assets/images/products/WB800-PF_A.jpg'),
      description: 'Un design pour aller vite en wing, wind ou surf.',
      disciplines: ['wing', 'wind'],
      details: [
        { txt: 'WB800/PF' },
        { txt: 'Surface 840cm2' },
        { txt: 'Volume 565cm3' },
        { txt: 'Span 800mm' },
        { txt: 'Chord 129,5mm' },
        { txt: 'Aspect ratio 7,6' },
        { txt: 'Connection type T6 (small chord, M6 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Razor 820 - 746cm2',
      price: 499,
      deal_price: 374,
      in_stock: true,
      image: require('@/assets/images/products/wing_R820.jpg'),
      description: 'Une aile qui décolle rapidement et permet d’aller relativement vite. Sa maniabilité à basse vitesse et sa stabilité à haute vitesse la rendent très polyvalente. Glisse et portance exceptionnelles, pumping facile.',
      disciplines: ['wing', 'surf', 'dw'],
      details: [
        { txt: 'WR820' },
        { txt: 'Surface 746cm2' },
        { txt: 'Volume 636cm3' },
        { txt: 'Span 820mm' },
        { txt: 'Chord 112,4mm' },
        { txt: 'Aspect ratio 8,84' },
        { txt: 'Connection type T6 (small chord, M6 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Razor PRO 825 - 746cm2',
      price: 509,
      in_stock: false,
      image: require('@/assets/images/products/WRP825_A.jpg'),
      description: 'Surf et downwind sont les domaines de prédilection de la gamme Razor PRO. Glisse et portance exceptionnelles pour sa petite surface.',
      disciplines: ['wing', 'surf', 'dw'],
      details: [
        { txt: 'WRP825' },
        { txt: 'Surface 746cm2' },
        { txt: 'Volume 665cm3' },
        { txt: 'Span 820mm' },
        { txt: 'Chord 112mm' },
        { txt: 'Aspect ratio 8,84' },
        { txt: 'Connection type T6 (small chord, M6 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Medusa PRO 869 - 854cm2',
      price: 549,
      in_stock: true,
      image: require('@/assets/images/products/WMP869_A.jpg'),
      description: 'La ligne Medusa PRO est un concentré de vitesse et de puissance. \n ' +
      'Conçue spécifiquement pour une accélération supérieure et des vitesses de pointe élevées, cette aile offre un pop incroyable et, grâce à la connexion T8 super solide, elle est le choix idéal pour les sessions de power freestyle et pour l’exécution de manœuvres engagées. \n ' +
      'La Medusa PRO 869 est meilleure en wing et wind dans des conditions de vent faible à moyen, mais  également en kite par vent léger.',
      disciplines: ['kite', 'wing', 'wind'],
      details: [
        { txt: 'WMP869' },
        { txt: 'Surface 854cm2' },
        { txt: 'Span 869mm' },
        { txt: 'Chord 144mm' },
        { txt: 'Aspect ratio 8,84' },
        { txt: 'Connection type: big chord, M8 screws' },
      ],
    },
    {
      name: 'SABFOIL Wing Razor PRO 875 - 843cm2',
      price: 519,
      in_stock: false,
      image: require('@/assets/images/products/wing_RP875.jpg'),
      description: 'Surf et downwind sont les domaines de prédilection de la gamme Razor PRO. Glisse et portance exceptionnelles pour sa petite surface.',
      disciplines: ['wing', 'surf', 'dw'],
      details: [
        { txt: 'WRP875' },
        { txt: 'Surface 843cm2' },
        { txt: 'Volume 775cm3' },
        { txt: 'Span 880mm' },
        { txt: 'Chord 118mm' },
        { txt: 'Aspect ratio 9,20' },
        { txt: 'Connection type T6 (small chord, M6 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Razor 880 - 843cm2',
      price: 509,
      deal_price: 381,
      in_stock: true,
      image: require('@/assets/images/products/wing_R880.jpg'),
      description: 'Une aile qui décolle rapidement et offre une grande plage de vitesse. Sa maniabilité à bas régime et sa stabilité à haute vitesse la rendent très polyvalente. Belle glisse et portance par vent modéré.',
      disciplines: ['wing', 'surf', 'pump', 'dw'],
      details: [
        { txt: 'WR880' },
        { txt: 'Surface 843cm2' },
        { txt: 'Volume 834cm3' },
        { txt: 'Span 880mm' },
        { txt: 'Chord 118mm' },
        { txt: 'Aspect ratio 9,2' },
        { txt: 'Connection type T6 (small chord, M6 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Medusa 899 - 1383cm2',
      price: 529,
      deal_price: 423,
      in_stock: true,
      image: require('@/assets/images/products/wing_M899.jpg'),
      description: 'Une aile dessinée en collaboration avec le rider pro Balz Müller. \n Accessible et manoeuvrante, parfaite pour le freestyle en wing, avec un peu plus de lift que la W799-BP',
      disciplines: ['wing', 'wind'],
      details: [
        { txt: 'WM899' },
        { txt: 'Surface 1383cm2' },
        { txt: 'Volume 1597cm3' },
        { txt: 'Span 899mm' },
        { txt: 'Chord 187mm' },
        { txt: 'Aspect ratio 5,84' },
        { txt: 'Connection type T8 (big chord, M8 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Medusa Balz PRO 909 - 1000cm2',
      price: 649,
      in_stock: true,
      image: require('@/assets/images/products/WMP909-PF_Ab.jpg'),
      description: 'Une aile dessinée en collaboration avec le rider pro Balz Müller. \n Décollage rapide, accélération puissante, pop incroyable... Freestyle!',
      disciplines: ['kite', 'wing', 'wind'],
      details: [
        { txt: 'WMP909/BM' },
        { txt: 'Surface 1000cm2' },
        { txt: 'Volume cm3' },
        { txt: 'Span 909mm' },
        { txt: 'Chord 161mm' },
        { txt: 'Aspect ratio 8,26' },
        { txt: 'Connection type T8 (big chord, M8 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Onda 945 PF - 1300cm2',
      price: 539,
      in_stock: false,
      image: require('@/assets/images/products/WO945-PF_A.jpg'),
      description: 'Une pure aile de surf, facile, manoeuvrante et offrant un bon lift.',
      disciplines: ['wing', 'surf'],
      details: [
        { txt: 'W945/PF' },
        { txt: 'Surface 1300cm2' },
        { txt: 'Volume 1499cm3' },
        { txt: 'Span 945mm' },
        { txt: 'Chord 185mm' },
        { txt: 'Aspect ratio 6,9' },
        { txt: 'Connection type T8 (big chord, M8 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing 950 - 1350cm2',
      price: 589,
      deal_price: 382,
      in_stock: true,
      image: require('@/assets/images/products/wing_950.jpg'),
      description: 'La petite soeur de la W1100, plus rapide et manoeuvrante, parfaite pour le freestyle et les runs de vitesse en wing',
      disciplines: ['wing', 'wind'],
      details: [
        { txt: 'W950' },
        { txt: 'Surface 1350cm2' },
        { txt: 'Span 950mm' },
        { txt: 'Chord 185mm' },
        { txt: 'Aspect ratio 6,65' },
        { txt: 'Connection type T8 (big chord, M8 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Leviathan 950 PF - 1300cm2',
      price: 649,
      in_stock: false,
      image: require('@/assets/images/products/WL950-PF_A.jpg'),
      description: 'Conçue spécialement pour le pumping, cette aile offre une excellente glisse. Elle va aussi très bien en freeride.',
      disciplines: ['wing', 'pump', 'sup', 'dw'],
      details: [
        { txt: 'WL950/PF' },
        { txt: 'Surface 1300cm2' },
        { txt: 'Volume 1728cm3' },
        { txt: 'Span 950mm' },
        { txt: 'Chord 170mm' },
        { txt: 'Aspect ratio 6,68' },
        { txt: 'Maximum thickness: 22,6mm' },
        { txt: 'Connection type T8 (big chord, M8 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Razor PRO 975 - 942cm2',
      price: 539,
      in_stock: false,
      image: require('@/assets/images/products/WRP975_A.jpg'),
      description: 'Surf et downwind sont les domaines de prédilection de la gamme Razor PRO. Glisse et portance exceptionnelles.',
      disciplines: ['wing', 'surf', 'dw'],
      details: [
        { txt: 'WRP975' },
        { txt: 'Surface 942cm2' },
        { txt: 'Volume cm3' },
        { txt: 'Span 980mm' },
        { txt: 'Chord 119mm' },
        { txt: 'Aspect ratio 10,20' },
        { txt: 'Connection type T6 (small chord, M6 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Medusa 999 PF - 1747cm2',
      price: 559,
      in_stock: false,
      image: require('@/assets/images/products/WM999-PF-A.jpg'),
      description: 'Une aile dessinée en collaboration avec le rider pro Balz Müller. Beau lift pour le light wind.',
      disciplines: ['wing'],
      details: [
        { txt: 'WM999/PF' },
        { txt: 'Surface 1747cm2' },
        { txt: 'Volume 1973cm3' },
        { txt: 'Span 999mm' },
        { txt: 'Chord 222mm' },
        { txt: 'Aspect ratio 5,71' },
        { txt: 'Connection type T8 (big chord, M8 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Blade 1000 PF - 987cm2',
      price: 549,
      in_stock: false,
      image: require('@/assets/images/products/WB1000-PF_A.jpg'),
      description: 'L’aile de race ultime pour le wind et le wing.',
      disciplines: ['wing', 'wind'],
      details: [
        { txt: 'WB1000/PF' },
        { txt: 'Surface 987cm2' },
        { txt: 'Volume 686cm3' },
        { txt: 'Span 1000mm' },
        { txt: 'Chord 135mm' },
        { txt: 'Aspect ratio 10,1' },
        { txt: 'Connection type T6 (small chord, M6 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing 1100 - 2100cm2',
      price: 599,
      deal_price: 389,
      in_stock: true,
      image: require('@/assets/images/products/wing_1100.jpg'),
      description: 'Un lift énorme, et encore bien maoeuvrante avec une belle vitesse de pointe pour une aile de cette taille.',
      disciplines: ['wing'],
      details: [
        { txt: 'W1100' },
        { txt: 'Surface 2100cm2' },
        { txt: 'Volume 2416cm3' },
        { txt: 'Span 1100mm' },
        { txt: 'Chord 246mm' },
        { txt: 'Aspect ratio 5,7' },
        { txt: 'Connection type T8 (big chord, M8 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Tortuga 1100 PF - 2100cm2',
      price: 599,
      in_stock: false,
      image: require('@/assets/images/products/WT1100-PF_A.jpg'),
      description: 'Un lift énorme, et encore bien maoeuvrante avec une belle vitesse de pointe pour une aile de cette taille.',
      disciplines: ['wing'],
      details: [
        { txt: 'WT1100/PF' },
        { txt: 'Surface 2100cm2' },
        { txt: 'Volume 2416cm3' },
        { txt: 'Span 1100mm' },
        { txt: 'Chord 246mm' },
        { txt: 'Aspect ratio 5,7' },
        { txt: 'Connection type T8 (big chord, M8 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing 1110 USED - 1180cm2',
      price: 629,
      deal_price: 345,
      in_stock: true,
      used: true,
      image: require('@/assets/images/products/wing_1110.jpg'),
      description: 'Une aile rapide pour le wing. \n Elle offre aussi une vitesse et une glisse inégalée en pumping pour les experts. Occasion, état quasiment neuf.',
      disciplines: ['wing', 'pump'],
      details: [
        { txt: 'W1110' },
        { txt: 'Surface 1180cm2' },
        { txt: 'Span 1110mm' },
        { txt: 'Chord 132,6mm' },
        { txt: 'Aspect ratio 10,4' },
        { txt: 'Connection type T6 (small chord, M6 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Leviathan 1150 PF - 1580cm2',
      price: 749,
      in_stock: false,
      image: require('@/assets/images/products/wing_L1150.jpg'),
      description: 'Conçue spécialement pour le pumping, cette aile offre une excellente glisse.',
      disciplines: ['wing', 'pump', 'sup', 'dw'],
      details: [
        { txt: 'WL1150/PF' },
        { txt: 'Surface 1580cm2' },
        { txt: 'Volume 2071cm3' },
        { txt: 'Span 1150mm' },
        { txt: 'Chord 170mm' },
        { txt: 'Aspect ratio 8,11' },
        { txt: 'Maximum thickness: 22,6mm' },
        { txt: 'Connection type T8 (big chord, M8 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing 1250 - 2400cm2',
      price: 649,
      deal_price: 421,
      in_stock: true,
      image: require('@/assets/images/products/wing_1250.jpg'),
      description: 'Pour voler dans le super light ou les plus petites vagues. \n Excellente en pumping.',
      disciplines: ['wing', 'sup'],
      details: [
        { txt: 'W1250' },
        { txt: 'Surface 2400cm2' },
        { txt: 'Span 1250mm' },
        { txt: 'Chord 246,5mm' },
        { txt: 'Aspect ratio 6,5' },
        { txt: 'Connection type T8 (big chord, M8 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Tortuga 1250 PF - 2400cm2',
      price: 649,
      in_stock: false,
      image: require('@/assets/images/products/WT1250-PF_A.jpg'),
      description: 'Pour voler dans le super light ou les plus petites vagues. \n Excellente en pumping.',
      disciplines: ['wing', 'sup'],
      details: [
        { txt: 'WT1250/PF' },
        { txt: 'Surface 2400cm2' },
        { txt: 'Volume 3309cm3' },
        { txt: 'Span 1250mm' },
        { txt: 'Chord 246,5mm' },
        { txt: 'Aspect ratio 6,5' },
        { txt: 'Connection type T8 (big chord, M8 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Leviathan PRO 1260 PF',
      price: 749,
      in_stock: true,
      image: require('@/assets/images/products/WLP1260-PF_AA.jpg'),
      description: 'Avec la gamme Leviathan PRO, aucun compromis. Glisse et vitesse pure.',
      disciplines: ['wing', 'pump', 'sup', 'dw'],
      details: [
        { txt: 'WLP1260' },
        { txt: 'Surface cm2' },
        { txt: 'Volume cm3' },
        { txt: 'Span mm' },
        { txt: 'Chord mm' },
        { txt: 'Aspect ratio ' },
        { txt: 'Maximum thickness: mm' },
        { txt: 'Connection type T8 (big chord, M8 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Leviathan 1350 PF - 1950cm2',
      price: 799,
      in_stock: false,
      image: require('@/assets/images/products/WL1350-PF_A.jpg'),
      description: 'Conçue spécialement pour le pumping, cette aile offre une excellente glisse également en sup ou pour une session de wing en super light wind.',
      disciplines: ['wing', 'pump', 'sup', 'dw'],
      details: [
        { txt: 'WL1350/PF' },
        { txt: 'Surface 1950cm2' },
        { txt: 'Volume 2423cm3' },
        { txt: 'Span 1350mm' },
        { txt: 'Chord 170mm' },
        { txt: 'Aspect ratio 9,35' },
        { txt: 'Maximum thickness: 22.6mm' },
        { txt: 'Connection type T8 (big chord, M8 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Leviathan 1550 PF - 2140cm2',
      price: 849,
      in_stock: false,
      image: require('@/assets/images/products/WL1550-PF_A.jpg'),
      description: 'Conçue spécialement pour le pumping, cette aile offre une excellente glisse.',
      disciplines: ['pump', 'sup'],
      details: [
        { txt: 'WL1550/PF' },
        { txt: 'Surface 2140cm2' },
        { txt: 'Volume 2757cm3' },
        { txt: 'Span 1550mm' },
        { txt: 'Chord 170mm' },
        { txt: 'Aspect ratio 11,3' },
        { txt: 'Maximum thickness: 22.6mm' },
        { txt: 'Connection type T8 (big chord, M8 screws)' },
      ],
    },
    {
      name: 'SABFOIL Wing Leviathan 1750 PF - 2400cm2',
      price: 999,
      in_stock: false,
      image: require('@/assets/images/products/WL1750-PF_A.jpg'),
      description: 'Conçue spécialement pour le pumping et la SUP sur eau plate, cette aile offre une excellente glisse.',
      disciplines: ['pump', 'sup'],
      details: [
        { txt: 'WL1750/PF' },
        { txt: 'Surface 2400cm2' },
        { txt: 'Volume 3097cm3' },
        { txt: 'Span 1750mm' },
        { txt: 'Chord 170mm' },
        { txt: 'Aspect ratio 12,7' },
        { txt: 'Maximum thickness: 22.9mm' },
        { txt: 'Connection type T8 (big chord, M8 screws)' },
      ],
    },
  ],
  stabs: [
    {
      name: 'SABFOIL Stab Flat 325 PF - 155cm2',
      price: 249,
      in_stock: false,
      image: require('@/assets/images/products/S325-PF_A.jpg'),
      description: 'Ce stab offre une grande maniabilité. Le petit frère du S370. Parfait pour surfer les vagues.',
      disciplines: ['kite', 'wing', 'surf', 'pump', 'dw'],
      details: [
        { txt: 'S325/PF' },
        { txt: 'Surface 155cm2' },
        { txt: 'Span 325mm' },
        { txt: 'Chord 58,9mm' },
        { txt: 'Aspect ratio 7,05' },
      ],
    },
    {
      name: 'SABFOIL Stab IKA 330 - 217cm2',
      price: 249,
      deal_price: 161,
      in_stock: true,
      image: require('@/assets/images/products/stab_330.jpg'),
      description: 'Accessible et offrant une bonne stabilité. Certifié IKA Youth Foil Class.',
      disciplines: ['kite'],
      details: [
        { txt: 'S330' },
        { txt: 'Surface 217cm2' },
        { txt: 'Span 330mm' },
        { txt: 'Chord 80mm' },
        { txt: 'Aspect ratio 4,3' },
      ],
    },
    {
      name: 'SABFOIL Stab Reverse 355 PF - 178cm2',
      price: 249,
      in_stock: true,
      image: require('@/assets/images/products/S355-PF_A.jpg'),
      description: 'Excellentes performances en terme de vitesse et de manoeuvrabilité, et tout de même assez stable à haute vitesse.',
      disciplines: ['kite', 'wing', 'wind', 'surf'],
      details: [
        { txt: 'stab_355/PF' },
        { txt: 'Surface WLP1260cm2' },
        { txt: 'Span 360mm' },
        { txt: 'Chord 58,48mm' },
        { txt: 'Aspect ratio 8,08' },
      ],
    },
    {
      name: 'SABFOIL Stab Flat 370 PF - 195cm2',
      price: 249,
      in_stock: false,
      image: require('@/assets/images/products/S370-PF_A.jpg'),
      description: 'Ce stab offre une grande maniabilité. Polyvalent, parfait dans toutes les disciplines, idéal pour carver.',
      disciplines: ['kite', 'wing', 'wind', 'surf', 'pump', 'sup', 'dw'],
      details: [
        { txt: 'S370/PF' },
        { txt: 'Surface 195cm2' },
        { txt: 'Span 370mm' },
        { txt: 'Chord 67,5mm' },
        { txt: 'Aspect ratio 7,0' },
      ],
    },
    {
      name: 'SABFOIL Stab Reverse 375 PF - 178cm2',
      price: 249,
      in_stock: true,
      image: require('@/assets/images/products/S375-PF_A.jpg'),
      description: 'Excellentes performances en terme de vitesse et de manoeuvrabilité, et tout de même assez stable à haute vitesse.',
      disciplines: ['kite', 'wing', 'wind', 'surf'],
      details: [
        { txt: 'stab_375/PF' },
        { txt: 'Surface 178cm2' },
        { txt: 'Span 380mm' },
        { txt: 'Chord 61,72mm' },
        { txt: 'Aspect ratio 8,08' },
      ],
    },
    {
      name: 'SABFOIL Stab Reverse 376 - 179cm2',
      price: 249,
      deal_price: 186,
      in_stock: true,
      image: require('@/assets/images/products/stab_376.jpg'),
      description: 'Ce stab assure une vitesse élevée et une grande maniabilité.',
      disciplines: ['kite', 'wing', 'wind', 'surf'],
      details: [
        { txt: 'S376' },
        { txt: 'Surface 179cm2' },
        { txt: 'Span 376mm' },
        { txt: 'Chord 56,2mm' },
        { txt: 'Aspect ratio 7,88' },
      ],
    },
    {
      name: 'SABFOIL Stab Gullwing 380 - 180cm2',
      price: 249,
      deal_price: 186,
      in_stock: true,
      image: require('@/assets/images/products/stab_380.jpg'),
      description: 'Accessible et stable, le S380 offre aussi une belle glisse et il est plus rapide que son grand frère le S430',
      disciplines: ['kite', 'wing', 'wind', 'surf', 'pump', 'dw'],
      details: [
        { txt: 'S380' },
        { txt: 'Surface 180cm2' },
        { txt: 'Span 380mm' },
        { txt: 'Chord 60mm' },
        { txt: 'Aspect ratio 8,18 ' },
      ],
    },
    {
      name: 'SABFOIL Stab Gullwing 380 PF - 180cm2',
      price: 249,
      in_stock: true,
      image: require('@/assets/images/products/S380-PF_A.jpg'),
      description: 'Accessible et stable, le S380 offre aussi une belle glisse et il est plus rapide que son grand frère le S430',
      disciplines: ['kite', 'wing', 'wind', 'surf', 'pump', 'dw'],
      details: [
        { txt: 'S380/PF' },
        { txt: 'Surface 180cm2' },
        { txt: 'Span 380mm' },
        { txt: 'Chord 60mm' },
        { txt: 'Aspect ratio 8,18 ' },
      ],
    },
    {
      name: 'SABFOIL Stab Reverse 395 PF - 198cm2',
      price: 249,
      in_stock: true,
      image: require('@/assets/images/products/S395-PF_A.jpg'),
      description: 'Excellentes performances en terme de vitesse et de manoeuvrabilité, et tout de même assez stable à haute vitesse.',
      disciplines: ['kite', 'wing', 'wind'],
      details: [
        { txt: 'S395/PF' },
        { txt: 'Surface 198cm2' },
        { txt: 'Span 400mm' },
        { txt: 'Chord 64,96mm' },
        { txt: 'Aspect ratio 8,08' },
      ],
    },
    {
      name: 'SABFOIL Stab Reverse 399 USED - 207cm2',
      price: 249,
      deal_price: 161,
      in_stock: true,
      used: true,
      image: require('@/assets/images/products/stab_399.jpg'),
      description: 'Mêmes performances que le S400, mais sans la certification IKA donc moins cher. Un stab très rapide. Occasion. Réparé avec soin après une touchette.',
      disciplines: ['kite', 'wing', 'wind'],
      details: [
        { txt: 'S399' },
        { txt: 'Surface 207cm2' },
        { txt: 'Span 400mm' },
        { txt: 'Chord 64mm' },
        { txt: 'Aspect ratio 7,73' },
      ],
    },
    {
      name: 'SABFOIL Stab IKA 400 - 207cm2',
      price: 309,
      deal_price: 216,
      in_stock: true,
      image: require('@/assets/images/products/stab_400.jpg'),
      description: 'Le meilleure stab pour améliorer ses performances en vitesse, le S400 se révèle être très accessible, en offrant une glisse pure que rien ne freine. Certifié IKA 2020/2024.',
      disciplines: ['kite', 'wing', 'wind'],
      details: [
        { txt: 'S400' },
        { txt: 'Surface 207cm2' },
        { txt: 'Span 400mm' },
        { txt: 'Chord 64mm' },
        { txt: 'Aspect ratio 7,73' },
      ],
    },
    {
      name: 'MOSES Stab 425 - 259cm2',
      price: 269,
      deal_price: 134,
      deals_only: true,
      used: true,
      in_stock: true,
      image: require('@/assets/images/products/stab_425_havok.jpg'),
      description: 'Très stable et rapide, ce stab d’occasion est en bon état, malgré quelques rayures. \n Offrant beaucoup de lift, idéal pour un rider lourd.',
      disciplines: ['kite'],
      details: [
        { txt: 'S425 ("Havok")' },
        { txt: 'Surface 259cm2' },
        { txt: 'Span 425mm' },
        { txt: 'Chord 71,5mm' },
        { txt: 'Aspect ratio 6,97' },
      ],
    },
    {
      name: 'SABFOIL Stab Flat 425 - 266cm2',
      price: 279,
      deal_price: 181,
      in_stock: true,
      image: require('@/assets/images/products/stab_425.jpg'),
      description: 'Le S425 est un mix entre le S370 et le S483.' +
      ' Plus manoeuvrant et rapide que le S483, plus stable et offrant un meilleur lift que le S370.',
      disciplines: ['kite', 'wing', 'wind', 'surf', 'sup', 'dw'],
      details: [
        { txt: 'S425' },
        { txt: 'Surface 266cm2' },
        { txt: 'Span 425mm' },
        { txt: 'Chord 78mm' },
        { txt: 'Aspect ratio 6,8' },
      ],
    },
    {
      name: 'SABFOIL Stab Gullwing 430 - 240cm2',
      price: 279,
      deal_price: 181,
      in_stock: true,
      image: require('@/assets/images/products/stab_430.jpg'),
      description: 'Très accessible et stable, le S430 offre aussi une belle glisse.',
      disciplines: ['kite', 'wing', 'wind', 'sup', 'dw'],
      details: [
        { txt: 'S430' },
        { txt: 'Surface 240cm2' },
        { txt: 'Span 430mm' },
        { txt: 'Chord 68mm' },
        { txt: 'Aspect ratio 7,7 ' },
      ],
    },
    {
      name: 'SABFOIL Stab 450 - 326cm2',
      price: 299,
      deal_price: 164,
      in_stock: true,
      image: require('@/assets/images/products/stab_450.jpg'),
      description: 'Compatible avec les ailes avant de grande surface, ce stab procure une belle stabilité.',
      disciplines: ['wing', 'wind'],
      details: [
        { txt: 'S450' },
        { txt: 'Surface 326cm2' },
        { txt: 'Span 450mm' },
        { txt: 'Chord 85mm' },
        { txt: 'Aspect ratio 6,22' },
      ],
    },
    {
      name: 'SABFOIL Stab 483 - 316cm2',
      price: 309,
      deal_price: 169,
      in_stock: true,
      image: require('@/assets/images/products/stab_483.jpg'),
      description: 'Ce stab donne beaucoup de maniabilité aux grandes ailes avant, en leur permettant aussi d’aller vite. \n' +
      'Occasion en parfait état, très peu utilisé.',
      disciplines: ['kite', 'wing', 'wind'],
      details: [
        { txt: 'S483' },
        { txt: 'Surface 316cm2' },
        { txt: 'Span 483mm' },
        { txt: 'Chord 85mm' },
        { txt: 'Aspect ratio 7,6' },
      ],
    },
    {
      name: 'SABFOIL Stab 483 used - 316cm2',
      price: 309,
      deal_price: 139,
      used: true,
      in_stock: true,
      image: require('@/assets/images/products/stab_483.jpg'),
      description: 'Ce stab donne beaucoup de maniabilité aux grandes ailes avant, en leur permettant aussi d’aller vite.',
      disciplines: ['kite', 'wing', 'wind'],
      details: [
        { txt: 'S483' },
        { txt: 'Surface 316cm2' },
        { txt: 'Span 483mm' },
        { txt: 'Chord 85mm' },
        { txt: 'Aspect ratio 7,6' },
      ],
    },
  ],
  masts: [
    {
      name: 'SABFOIL Kraken 73 Mast R8',
      price: 719,
      deal_price: 575,
      in_stock: true,
      image: require('@/assets/images/products/mast_73K.jpg'),
      description: 'Le profil des mâts Kraken a été optimisé pour obtenir un maximum de performance dans les différentes disciplines. \n' +
      'Taille idéale aussi bien pour un débutant en kite que pour un expert en pumping ou en surf. \n' +
      'Connection à la planche par plate ou tuttle. \n' +
      'Possibilité d’upgrade avec le Quick Release System. \n \n' +
      '<b> Plate et Tuttle PAS inclus. \n Kraken Quick Release System PAS inclu. \n' +
      'Nécessite un fuselage Kraken. </b>',
      disciplines: ['kite', 'wing', 'wind', 'surf', 'sup', 'dw'],
      details: [
        { txt: 'M73K' },
        { txt: 'Height 730mm' },
        { txt: 'Weight 1150g [±5%]' },
        { txt: 'Mast-Fuselage Connection R8' },
      ],
    },
    {
      name: 'SABFOIL Kraken 73 PF Mast R8',
      price: 749,
      in_stock: false,
      image: require('@/assets/images/products/M73K-PF_A.jpg'),
      description: 'Le profil des mâts Kraken a été optimisé pour obtenir un maximum de performance dans les différentes disciplines. \n' +
      'Connection à la planche par plate ou tuttle. \n' +
      'Possibilité d’upgrade avec le Quick Release System. \n \n' +
      '<b> Plate et Tuttle PAS inclus. \n Kraken Quick Release System PAS inclu. \n' +
      'Nécessite un fuselage Kraken. </b>',
      disciplines: ['kite', 'wing', 'wind', 'surf', 'sup', 'dw'],
      details: [
        { txt: 'M73K/PF' },
        { txt: 'Height 730mm' },
        { txt: 'Weight 1358g [±5%]' },
        { txt: 'Mast-Fuselage Connection R8' },
      ],
    },
    {
      name: 'SABFOIL Kraken 73 PF Pump Mast R8',
      price: 759,
      in_stock: false,
      image: require('@/assets/images/products/M73PLK-PF_A.jpg'),
      description: 'Le profil des mâts Kraken a été optimisé pour obtenir un maximum de performance dans les différentes disciplines. \n' +
      'Taille idéale aussi bien pour un débutant en kite que pour un expert en pumping ou en surf. \n' +
      'Connection à la planche par plate ou tuttle. \n' +
      'Possibilité d’upgrade avec le Quick Release System. \n \n' +
      'Ce mât offre une rigidité accrue pour le pumping. \n \n' +
      '<b> Plate et Tuttle PAS inclus. \n Kraken Quick Release System PAS inclu. \n' +
      'Nécessite un fuselage Kraken. </b>',
      disciplines: ['wing', 'surf', 'pump', 'sup'],
      details: [
        { txt: 'M73PLK/PF' },
        { txt: 'Height 730mm' },
        { txt: 'Weight 1420g [±5%]' },
        { txt: 'Mast-Fuselage Connection R8' },
      ],
    },
    {
      name: 'SABFOIL Kraken 83 Mast R8',
      price: 779,
      deal_price: 623,
      in_stock: true,
      image: require('@/assets/images/products/mast_83K.jpg'),
      description: 'Le profil des mâts Kraken a été optimisé pour obtenir un maximum de performance dans les différentes disciplines. \n' +
      'Le mât de 83cm a une taille utilisable dans toutes les disciplines. \n' +
      'Connection à la planche par plate ou tuttle. \n' +
      'Possibilité d’upgrade avec le Quick Release System. \n \n' +
      '<b> Mât d’occasion en parfait état, très peu utilisé. \n \n' +
      'Plate et Tuttle PAS inclus. \n Kraken Quick Release System PAS inclu. \n' +
      'Nécessite un fuselage Kraken. </b>',
      disciplines: ['kite', 'wing', 'wind', 'surf', 'sup', 'dw'],
      details: [
        { txt: 'M83K' },
        { txt: 'Height 830mm' },
        { txt: 'Weight 1350g [±5%]' },
        { txt: 'Mast-Fuselage Connection R8' },
      ],
    },
    {
      name: 'SABFOIL Kraken 83 PF Mast R8',
      price: 849,
      in_stock: false,
      image: require('@/assets/images/products/M83K-PF_A.jpg'),
      description: 'Le profil des mâts Kraken a été optimisé pour obtenir un maximum de performance dans les différentes disciplines. \n' +
      'Connection à la planche par plate ou tuttle. \n' +
      'Possibilité d’upgrade avec le Quick Release System. \n \n' +
      '<b> Plate et Tuttle PAS inclus. \n Kraken Quick Release System PAS inclu. \n' +
      'Nécessite un fuselage Kraken. </b>',
      disciplines: ['kite', 'wing', 'wind', 'dw'],
      details: [
        { txt: 'M83K/PF' },
        { txt: 'Height 830mm' },
        { txt: 'Weight 1458g [±5%]' },
        { txt: 'Mast-Fuselage Connection R8' },
      ],
    },
    {
      name: 'SABFOIL Kraken 83 PF Pump Mast R8',
      price: 859,
      in_stock: false,
      image: require('@/assets/images/products/M83PLK-PF_A.jpg'),
      description: 'Le profil des mâts Kraken a été optimisé pour obtenir un maximum de performance dans les différentes disciplines. \n' +
      'Le mât de 83cm a une taille utilisable dans toutes les disciplines. \n' +
      'Connection à la planche par plate ou tuttle. \n' +
      'Possibilité d’upgrade avec le Quick Release System. \n \n' +
      'Ce mât offre une rigidité accrue pour le pumping. \n \n' +
      '<b> Plate et Tuttle PAS inclus. \n Kraken Quick Release System PAS inclu. \n' +
      'Nécessite un fuselage Kraken. </b>',
      disciplines: ['wing', 'surf', 'pump', 'sup'],
      details: [
        { txt: 'M83PLK/PF' },
        { txt: 'Height 830mm' },
        { txt: 'Weight 1550g [±5%]' },
        { txt: 'Mast-Fuselage Connection R8' },
      ],
    },
    {
      name: 'SABFOIL Kraken 93 PF Mast R8',
      price: 899,
      in_stock: false,
      image: require('@/assets/images/products/M93K-PF_A.jpg'),
      description: 'Le profil des mâts Kraken a été optimisé pour obtenir un maximum de performance dans les différentes disciplines. \n' +
      'Connection à la planche par plate ou tuttle. \n' +
      'Possibilité d’upgrade avec le Quick Release System. \n \n' +
      '<b> Plate et Tuttle PAS inclus. \n Kraken Quick Release System PAS inclu. \n' +
      'Nécessite un fuselage Kraken. </b>',
      disciplines: ['kite', 'wing', 'wind', 'dw'],
      details: [
        { txt: 'M93K/PF' },
        { txt: 'Height 930mm' },
        { txt: 'Weight 1660g [±5%]' },
        { txt: 'Mast-Fuselage Connection R8' },
      ],
    },
    {
      name: 'SABFOIL Kraken 96 Piuma Mast R8',
      price: 1199,
      in_stock: false,
      image: require('@/assets/images/products/M96P_A.jpg'),
      description: 'Mât haut de gamme optimisé pour obtenir un maximum de performance dans les différentes disciplines. \n' +
      'Profil fin pour minimiser la trainée avec le meilleur ratio rigidité/torsion/poids de la gamme Sabfoil. \n' +
      'Possibilité d’upgrade avec le Quick Release System. \n \n' +
      '<b> Plate et Tuttle PAS inclus. \n Kraken Quick Release System PAS inclu. \n' +
      'Très rigide et performant, mais pas conçu pour supporter les impacts violents en freestyle engagé ou big air. </b>',
      disciplines: ['kite', 'wing', 'dw'],
      details: [
        { txt: 'M96P' },
        { txt: 'Height 930mm' },
        { txt: 'Weight 1400g [±5%]' },
        { txt: 'Mast-Fuselage Connection R8' },
      ],
    },
    {
      name: 'SABFOIL Kraken 106 Piuma Mast R8',
      price: 1299,
      in_stock: false,
      image: require('@/assets/images/products/M106P_A.jpg'),
      description: 'Mât haut de gamme optimisé pour obtenir un maximum de performance dans les différentes disciplines. \n' +
      'Profil fin pour minimiser la trainée avec le meilleur ratio rigidité/torsion/poids de la gamme Sabfoil. \n' +
      'Possibilité d’upgrade avec le Quick Release System. \n \n' +
      '<b> Plate et Tuttle PAS inclus. \n Kraken Quick Release System PAS inclu. \n' +
      'Très rigide et performant, mais pas conçu pour supporter les impacts violents en freestyle engagé ou big air. </b>',
      disciplines: ['kite', 'wing', 'dw'],
      details: [
        { txt: 'M106P' },
        { txt: 'Height 1030mm' },
        { txt: 'Mast-Fuselage Connection R8' },
      ],
    },
    {
      name: 'Q02K - Titanium Quick Release System',
      price: 100,
      in_stock: true,
      image: require('@/assets/images/products/Q02K.jpg'),
      description: 'Upgrade permettant de laisser plate (CP02K) ou tuttle (T04K) sur la planche et de connecter le mât rapidement avec une simple vis conique. \n Version en titane: résistance et design améliorés. ',
      disciplines: ['kite', 'wing', 'wind', 'surf', 'pump', 'sup', 'dw'],
      details: [
        { txt: 'Q02K' },
        { txt: '1 x Titanium Pin' },
        { txt: '1 x Titanium Quick Release Module' },
        { txt: '2 x Default inox shims 6.1x14x0.5' },
        { txt: '1 x 6mm Hex Key' },
        { txt: '2 x Socket Head Cap Screws M6x30' },
        { txt: '20 x Adjustment inox shims 6.1x12x0.15' },
      ],
    },
    {
      name: 'Kraken Mast Plate',
      price: 199,
      deal_price: 139,
      in_stock: true,
      image: require('@/assets/images/products/mast_P02K.jpg'),
      description: 'Connection à la planche (système modulable Kraken) conçue pour un maximum de résistance. \n Possibilité d’upgrade avec le Quick Release System.',
      disciplines: ['kite', 'wing', 'wind', 'surf', 'pump', 'sup', 'dw'],
      details: [
        { txt: 'P02K' },
        { txt: 'Weight 750g [±5%]' },
      ],
    },
    {
      name: 'Kraken Mast Plate - used',
      price: 199,
      deal_price: 109,
      in_stock: true,
      used: true,
      image: require('@/assets/images/products/mast_P02K.jpg'),
      description: 'Connection à la planche (système modulable Kraken) conçue pour un maximum de résistance. \n Possibilité d’upgrade avec le Quick Release System.',
      disciplines: ['kite', 'wing', 'wind', 'surf', 'pump', 'sup', 'dw'],
      details: [
        { txt: 'P02K' },
        { txt: 'Weight 750g [±5%]' },
      ],
    },
    {
      name: 'Sabfoil Carbon Rail Plate (Titanium inserts)',
      price: 279,
      in_stock: true,
      image: require('@/assets/images/products/mast_CP02K_Ti.jpg'),
      description: 'Connection à la planche (système modulable Kraken) conçue pour un maximum de légéreté et de résistance. \n Possibilité d’upgrade avec le Quick Release System Titanium.',
      disciplines: ['kite', 'wing', 'wind', 'surf', 'pump', 'sup', 'dw'],
      details: [
        { txt: 'CP02K/Ti' },
        { txt: 'Weight 485g [±5%]' },
      ],
    },
    {
      name: 'SABFOIL Mast 91Y Carbon',
      price: 879,
      deal_price: 571,
      in_stock: true,
      image: require('@/assets/images/products/mast_91.jpg'),
      description: 'Les mâts SABFOIL sont axés vers la performance et la maniabilité. \n IKA YOUTH FOIL CLASS.',
      disciplines: ['kite'],
      details: [
        { txt: 'M91Y' },
        { txt: 'Height 910mm' },
        { txt: 'Weight 1693g [±5%]' },
        { txt: 'Maximum thickness 13,50mm' },
      ],
    },
    {
      name: 'MOSES Mast 101 Carbon',
      price: 1119,
      deal_price: 559,
      used: true,
      in_stock: true,
      image: require('@/assets/images/products/mast_101_MOSES.jpg'),
      description: 'Axé vers la performance et la maniabilité. \n Mât d’occasion en très bon état.',
      disciplines: ['kite'],
      details: [
        { txt: 'M101' },
        { txt: 'Height 1010mm' },
      ],
    },
  ],
  fuselages: [
    {
      name: 'SABFOIL Fuselage 603 T6 KMS',
      price: 249,
      in_stock: true,
      image: require('@/assets/images/products/fuselage_603K.jpg'),
      description: 'Fuselage de 603mm extrêmement résistant. \n Pour les petites ailes avant à la corde (T6; vis M6). \n L’utilisation de vis M8 pour la connection au mât offre résistance et performance.',
      disciplines: ['kite', 'wing', 'surf'],
      details: [
        { txt: 'F603K' },
        { txt: 'Weight 690g [±5%]' },
        { txt: 'Front wing connection type T6' },
      ],
    },
    {
      name: 'SABFOIL Fuselage 653 T6 KMS',
      price: 249,
      in_stock: true,
      image: require('@/assets/images/products/fuselage_653K.jpg'),
      description: 'Fuselage de 653mm extrêmement résistant. \n Pour les petites ailes avant à la corde (T6; vis M6). \n L’utilisation de vis M8 pour la connection au mât offre résistance et performance.',
      disciplines: ['kite', 'wing', 'surf'],
      details: [
        { txt: 'F653K' },
        { txt: 'Weight 750g [±5%]' },
        { txt: 'Front wing connection type T6' },
      ],
    },
    {
      name: 'SABFOIL Fuselage 663 T8 KMS',
      price: 249,
      in_stock: true,
      image: require('@/assets/images/products/fuselage_663K.jpg'),
      description: 'Fuselage de 663mm extrêmement résistant. \n Pour les grandes ailes avant à la corde (T8; vis M8). \n L’utilisation de vis M8 pour la connection au mât offre résistance et performance.',
      disciplines: ['kite', 'wing', 'surf', 'pump'],
      details: [
        { txt: 'F663K' },
        { txt: 'Weight g [±5%]' },
        { txt: 'Front wing connection type T8' },
      ],
    },
    {
      name: 'SABFOIL Fuselage 703 T8 KMS',
      price: 249,
      in_stock: true,
      image: require('@/assets/images/products/fuselage_703K.jpg'),
      description: 'Fuselage de 703mm extrêmement résistant. \n Pour les grandes ailes avant à la corde (T8; vis M8). \n Avec le système modulable Kraken tous les mâts et fuselages sont compatibles entre eux. \n L’utilisation de vis M8 pour la connection au mât offre résistance et performance.',
      disciplines: ['kite', 'wing', 'surf', 'pump', 'sup', 'dw'],
      details: [
        { txt: 'F703K' },
        { txt: 'Weight 900g [±5%]' },
        { txt: 'Front wing connection type T8' },
      ],
    },
    {
      name: 'SABFOIL Fuselage 647',
      price: 309,
      deal_price: 185,
      used: true,
      in_stock: true,
      image: require('@/assets/images/products/fuselage_647.jpg'),
      description: 'Alliage aluminium/manganèse extrêmement résistant. \n Pour les petites ailes avant (W590, W671, W695, W740…)',
      disciplines: ['kite', 'wing', 'surf'],
      details: [
        { txt: 'FK647' },
      ],
    },
    {
      name: 'SABFOIL Fuselage 899-HS',
      price: 389,
      deal_price: 249,
      in_stock: true,
      image: require('@/assets/images/products/fuselage_899.jpg'),
      description: 'Alliage aluminium/manganèse extrêmement résistant. Pour le windsurf.',
      disciplines: ['wind'],
      details: [
        { txt: 'F899-HS' },
      ],
    },
  ],
};

Object.entries(allProducts).forEach((entry) => {
  const products = entry[1];

  products.forEach((product) => {
    Object.assign(product, {
      // create a uid from the product's name
      uid: product.name.replaceAll(' - ', ' ').replaceAll(' ', '_').toLowerCase(),
    });
  });
});

const store = new Vuex.Store({
  state: {
    all_products: allProducts,
    all_disciplines: allDisciplines,
    cartProducts: [],
    showModal: false,
    showPopupCart: false,
  },

  getters: {
    getDisciplines: state => () => state.all_disciplines,
    getProducts: state => (category, discipline) => {
      // get all products
      let products = Object.values(state.all_products)
        .reduce((prod, p) => prod.concat(p), []);

      if (category.includes('deals')) {
        // take only products with that have special deals
        products = products.filter(p => p.deal_price);
      } else {
        if (category && state.all_products[category]) {
          products = state.all_products[category];
        }

        // remove items that should only appear in deals tab
        products = products.filter(p => p.deals_only === undefined || p.deals_only === false);
      }

      if (discipline) {
        products = products.filter(p => p.disciplines.includes(discipline));
      }

      return products;
    },
    getProductFromUid: state => (uid) => {
      const allTheProducts = Object.values(state.all_products)
        .reduce((prod, p) => prod.concat(p), []);
      const matchingProducts = allTheProducts.filter(p => p.uid === uid);
      return matchingProducts[0];
    },
    getProductsInCart: state => state.cartProducts,
    getShowModal: state => state.showModal,
    getPopupCart: state => state.showPopupCart,
  },

  mutations: {
    ADD_PRODUCT: (state, product) => {
      state.cartProducts.push(product);
    },
    REMOVE_PRODUCT: (state, product) => {
      state.cartProducts.splice(product, 1);
    },
    SHOW_MODAL: (state) => {
      state.showModal = !state.showModal;
    },
    SHOW_POPUP_CART: (state) => {
      state.showPopupCart = !state.showPopupCart;
    },
  },

  actions: {
    addProduct: (context, product) => {
      context.commit('ADD_PRODUCT', product);
    },
    removeProduct: (context, product) => {
      context.commit('REMOVE_PRODUCT', product);
    },
    showOrHiddenModal: (context) => {
      context.commit('SHOW_MODAL');
    },
    showOrHiddenPopupCart: (context) => {
      context.commit('SHOW_POPUP_CART');
    },
  },
});

export default store;



// WEBPACK FOOTER //
// ./src/store.js